<app-title-bar titleText="i18n.core.navigation.product-assets"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <button class="btn btn-primary me-2 btn-fixedw rounded right" type="button"
      [disabled]="selectedProducts.length === 0" (click)="assingAsset()">
      <span class="e-icons icon-cloud--upload"></span>
      {{ 'i18n.domain.assets.product-assets.assign-assets' | translate }}
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <ejs-grid #grid class="grid-with-toolbar grid-configuration" width="100%" rowHeight="38" [dataSource]="data"
      [allowPaging]="true" [pageSettings]='pageSettings' [allowSorting]="true" [allowFiltering]="true"
      [filterSettings]="filterSettings" [childGrid]='childGrid' (actionBegin)="actionBegin($event)"
      (actionComplete)="actionComplete($event)" (dataBound)="dataBound()" (detailDataBound)='detailDataBound($event)'
      (rowSelected)="rowSelectedChanged()" (rowDeselected)="rowSelectedChanged()">
      <e-columns>
        <e-column type='checkbox' width='50'></e-column>
        <e-column field="sKU" [isPrimaryKey]="true" width="110"
          headerText="{{'i18n.domain.assets.product-assets.grid.item' | translate}}" clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="manItemInfo" width="200" type="string"
          headerText="{{'i18n.domain.assets.product-assets.grid.vendor-item' | translate}}"
          clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="description" headerText="{{'i18n.domain.assets.product-assets.grid.name' | translate}}"
          clipMode="EllipsisWithTooltip" type="string">
        </e-column>
        <e-column field="brandId" width="100" type="string"
          headerText="{{'i18n.domain.assets.product-assets.grid.brand' | translate}}" clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="brandSubId" width="120" type="string"
          headerText="{{'i18n.domain.assets.product-assets.grid.subbrand' | translate}}" clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="shopIds" width="120" type="string" [allowFiltering]="false" [allowSorting]="false"
          headerText="{{'i18n.domain.assets.product-assets.grid.shops' | translate}}" clipMode="EllipsisWithTooltip">
        </e-column>
        <e-column field="{{hasAssetsField}}" [filter]="hasAssetFilterSettings" [allowSorting]="false" type="boolean"
          width="100" headerText="{{'i18n.domain.assets.product-assets.grid.assets' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #filterItemTemplate let-data>{{formatHasAssets(data)}}</ng-template>
          <ng-template #template let-data>
            @if(data.assets.length){
              <div class="e-icons icon-checkmark align-middle"></div>
            }
            @if(!data.assets.length){
              <div class="e-icons icon-close align-middle"></div>
            }
          </ng-template>
        </e-column>
        <e-column field="{{syncStateField}}" [filter]="syncStateFilterSettings" [allowSorting]="false" type="string"
          headerText="{{'i18n.domain.assets.product-assets.grid.shop-state' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #filterItemTemplate let-data>{{formatSyncState(data)}}</ng-template>
          <ng-template #template let-data>
            <div>{{getProductsAssetSyncState(data) | translate}}
              @if(data.isPublishedToWeb === false){
                <span class="icon-ai-status--rejected align-middle text-danger" title="{{'i18n.domain.assets.product-assets.grid.unpublish-info' | translate}}"></span>
              }
              @if(hasError(data)){
                <span class="icon-error align-middle text-danger" title="{{'i18n.domain.assets.product-assets.grid.error-info' | translate}}"></span>
              }
            </div>
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>

<app-product-assets-single-edit (OnClose)="OnCloseEditForm()"></app-product-assets-single-edit>
<app-product-assets-multi-upload (OnClose)="OnCloseEditForm()"></app-product-assets-multi-upload>

<!-- Syncfusion workaround for child grid templates : https://www.syncfusion.com/forums/161004/grid-child -->
<ng-template #childtypetemplate let-data>
  {{getAssetTypeName(data.type) | translate}}
</ng-template>

<ng-template #childsyncstatustemplate let-data>
  <span title="{{data.syncMessage}}">{{getAssetSyncStatusName(data.syncStatus) | translate}}</span>
</ng-template>

<ng-template #childkeytemplate let-data>
  @if(data.isKey){
    <div class="e-icons icon-checkmark align-middle"></div>
  }
</ng-template>

<ng-template #childshopstemplate let-data>
  <div>
    @for (shop of data.shops; track shop.shopId) {
      <div class="shop-info flex-line">
        <div>{{shop.shopId}}</div>
        @if(!shop.isKey){
          <div class="flex-line empty-key-icon">
            <button type="button" title="{{'i18n.domain.assets.product-assets.subgrid.set-as-key' | translate}}"
              class="e-lib e-btn e-control icon-btn e-icon-btn e-edit-delete e-editbutton"
              (click)="setAssetShopAsKey(data.id, shop.shopId)">
              <span class="e-icons icon-password grid-command"></span>
            </button>
          </div>
        }
        @if(shop.isKey){
          <div class="flex-line">
            <div class="key-icon"></div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #gridcommandstemplate let-data>
  <div class="">
    <button type="button" title="{{'i18n.domain.assets.product-assets.subgrid.set-as-key-for-all-shops' | translate}}"
      class="e-lib e-btn e-control icon-btn e-icon-btn e-edit-delete e-editbutton" (click)="setAssetAsKey(data)"
      [disabled]="!data.canBeSetAsKey">
      <span class="e-icons icon-password grid-command"></span>
    </button>
    <button type="button" title="{{'i18n.domain.assets.product-assets.subgrid.edit' | translate}}"
      class="e-lib e-btn e-control icon-btn e-icon-btn e-edit-delete e-editbutton" (click)="editAsset(data)">
      <span class="e-icons icon-edit grid-command"></span>
    </button>
    <button type="button" title="{{'i18n.domain.assets.product-assets.subgrid.delete' | translate}}"
      class="e-lib e-btn e-control icon-btn e-icon-btn e-edit-delete e-editbutton" (click)="deleteAsset(data)"
      [disabled]="!data.isDeletable">
      <span class="e-icons icon-trash-can grid-command"></span>
    </button>
  </div>
</ng-template>

<ng-template #previewTemplate let-data>
  <div class="asset-preview">
    <a [href]="data.fileLink" target="_blank">
      <img src="{{getPreviewLink(data)}}" [alt]="data.altText ?? ('i18n.domain.assets.product-assets.subgrid.image-not-available' | translate)" onerror=""/>
    </a>
  </div>
</ng-template>

<div id="dlgContent" style="visibility: hidden" class='dialog-content'>
  <span class="e-icons icon-danger"></span>
  <h6 class="text-danger">
    {{'i18n.domain.assets.product-assets.subgrid.delete-managed-assets-message' | translate}}
  </h6>

</div>
